import { render, staticRenderFns } from "./Cookbook.vue?vue&type=template&id=38df9a0c&"
import script from "./Cookbook.vue?vue&type=script&lang=js&"
export * from "./Cookbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports